import React, { useState, useEffect } from 'react';
import BasicCard from "../../components/basics/cards/BasicCard";
import { FilterAPIService } from "../../services/apis/FilterAPIService";
import { ErrorService } from "../../services/ErrorService"
import './basicReport.css'
// This is only used for Basic Reports
// When you want to do more complicated stuff use filtersettings

function BasicReportSettings({ filterArray, setFilterArray, pageConfig, updatingFilter, clearMessages }) {
    const [filterSettings, setFilterObject] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState("");

    const { apiName, controllerName, pageSettings, parameters } = pageConfig
    useEffect(
        () => {
            FilterAPIService.getFilters(`${controllerName}/FilterSettings${parameters}`)
                .then(data => {
                    setIsLoading(false);
                    if (!data.error) {
                        setFilterObject(data);
                        // Loop through filter objects and set default values in filterArray
                        const newFilterArray = [];
                        data.listOfFilters.forEach(filterList => {
                            const filterIndex = newFilterArray.findIndex(item => item.id === filterList.filterId);
                            if (filterIndex === -1) {
                                newFilterArray.push({ id: filterList.filterId, value: filterList.defaultValue });
                            } else {
                                newFilterArray[filterIndex].value = filterList.defaultValue;
                            }
                        });
                        setFilterArray(newFilterArray);
                        setError(false)
                    }
                    else {
                        setError(ErrorService.getErrorMessage(data.error.status));
                    }
                })
                .catch(error => console.error(error));
    }, [apiName, controllerName]);

    const handleChange = (ev) => {
        if (typeof clearMessages !== "undefined") {
            clearMessages();
        }
        const filterValue = ev.target.value;
        const filterId = ev.target.name;
        const newFilterArray = [...filterArray]
        // Find the index of the filter with matching id in the filterArray
        const filterIndex = newFilterArray.findIndex(item => item.id === filterId);

        // If filterIndex is -1, it means the filterId is not present in the newFilterArray
        if (filterIndex === -1) {
            // Add a new object to the newFilterArray
            newFilterArray.push({ id: filterId, value: filterValue });
        } else {
            // Update the value of the filter with matching id
            newFilterArray[filterIndex].value = filterValue;
        }

        setFilterArray(newFilterArray);
    };

    return (
        <BasicCard cardConfig={{ cardTitle: pageSettings ? pageSettings.name + ' settings' : '', cardHeadingElement: 'h5'}}>
            {error ? <p style={{ color: 'red' }}>{error}</p> : ""}
            <div className='brs-selections' style={{ opacity: updatingFilter ? '0.7' : '1' }}>
                {isLoading ? <span style={{ marginRight: '20px' }}><p>Loading filters...</p></span> : ""}
                {
                    filterSettings?.listOfFilters?.length > 0 ? (
                        filterSettings.listOfFilters.map((filterList, index) => (
                            <span style={{ marginRight: '20px' }} key={index} className='brs-select-span'>
                                <h6>{filterList.filterName}</h6>
                                <select disabled={updatingFilter} className='brs-select' key={filterList.filterId} onChange={handleChange} name={filterList.filterId} value={filterArray.find(item => item.id === filterList.filterId)?.value || filterList.defaultValue}>
                                    {
                                        filterList.filterObjects.map((filterObject, index) => (
                                            <option key={index} value={filterObject.id}>
                                                {filterObject.name}
                                            </option>
                                        ))}
                                </select>
                            </span>
                        ))
                    )
                    : ""
                }
            </div>
        </BasicCard>
    );
}
export default BasicReportSettings